import { Injectable } from '@angular/core';
import { Helpers } from "../../../helpers";

@Injectable()
export class ExcelWorkService {
    constructor() {

    }

    downloadXLS(name: string, data: any) {
        var contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        console.log(data);
        let blob = new Blob([data._body], { type: contentType });
        const link = document.createElement("a");
        document.body.appendChild(link);
    //    let link = document.createElement('a');
        link.href = URL.createObjectURL(data);
        link.download = name;
        link.click();

        /*var link = document.createElement('a');

         link.href = data.url;
         link.download = name;

         link.click();*/

        Helpers.setLoading(false);
    }
}
